/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fair_Suave_Lemming_AriseInputs */

const fr_fair_suave_lemming_arise = /** @type {(inputs: Fair_Suave_Lemming_AriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles`)
};

/**

* @param {Fair_Suave_Lemming_AriseInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fair_suave_lemming_arise = /** @type {((inputs?: Fair_Suave_Lemming_AriseInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Suave_Lemming_AriseInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fair_suave_lemming_arise(inputs)
});